import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Page from '../../../components/Page.js';
import Container from '@material-ui/core/Container';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    padding: '1rem',
  },
  skeleton: {
    marginBottom: '1rem',
  },
}));

const ContentSkeleton = () => {
  const classes = useStyles();
  return (
    <Page title="Clickability">
      <Container fixed disableGutters={true} maxWidth="lg" className={classes.root}>
        <Skeleton variant="text" width="50%" height="8rem" className={classes.skeleton}/>
        <Skeleton variant="rect" width="100%" height="50vh" className={classes.skeleton}/>
      </Container>
    </Page>
  );
};

export default ContentSkeleton;
